import React, { Component, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { connect } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import "./new-select.css";

export default function NewSelect({
  onRenderValue = () => null,
  options = [
    { midiaid: 1, label: "Telefone" },
    { midiaid: 2, label: "Webchat" },
    { midiaid: 3, label: "Email" },
    { midiaid: 4, label: "Facebook" },
  ],
  value,
  onSelect,
  bind,
}) {
  return (
    <div>
      <FormControl sx={{ minWidth: 80 }}>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          value={value ? value : "Telefone"}
          onChange={(select) => {
            onSelect(bind, value, select.target.value);
          }}
          autoWidth
          renderValue={
            onRenderValue
              ? onRenderValue
              : (selected) => {
                  return <div>{selected}</div>;
                }
          }
        >
          {options.map((option) => (
            <MenuItem value={option.midiaid} name={option.label}>
              {option.label}
            </MenuItem>
          ))}
          {/* <MenuItem value={10}>Telefone</MenuItem>
          <MenuItem value={21}>Facebook</MenuItem>
          <MenuItem value={22}>Linkedin</MenuItem> */}
        </Select>
      </FormControl>
    </div>
  );
}
